import { Grid } from "@material-ui/core"
import {
  InputRadioButton,
  InputTextMaster,
  MasterButton,
  ModalDeleteConfirm,
} from "App/Component/ui"
import {
  BASE_URL_VCLAIM,
  DEFAULT_SHOW_BUTTON_SEARCH,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  instance2,
  instance3,
  V1,
  // BASE_URL_EMR,
  instancePenunjang
} from "App/constants"
import { getToken, getUserName } from "App/utils/cookies"
import {
  defaultDateDisplay,
  today,
  defaultToastError,
  isNull,
  toUTCFormat,
  defaultToastSuccess,
  optionCaraMasuk,
} from "App/utils/helpers"
import React, { useEffect, useState } from "react"
import { KODE_PRINTER_SETTING, removeZeroInFront, URL_SETTING } from "utils/all"
import { SUMBER_PENJUALAN_OTOMATIS_REGISTRASI } from "utils/billing"
import { KODE_PPK_RUJUKAN, NAMA_PPK_RUJUKAN } from "utils/registrations"
import { getJasaDokterByMsJasa } from "../MasterData/MasterPenjualan/Jasa/ui/ModalJasaDokter"
import { STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT } from "../Penjualan/InputPenjualan/ui"
import { ModalCancel, urlFilterInternal } from "./KunjunganRawatJalan/ui"
import { POLI_TUJUAN_IGD } from "./KunjunganRawatJalan/ui/ModalSEP/constants"

export const prefixNoRM = (str) => {
  if (isNull(str)) {
    return ""
  } else {
    let temp = str.toString()
    let tamp = ""
    for (let i = 0; i < 9 - temp.length; i++) {
      tamp += "0"
    }
    tamp += temp

    return tamp
  }
}

export const handleClickCetakLabel = (formData, id, url) => {
  const lengthRM = parseInt(formData.patients_id.toString().length)
  const lengthNoRegis = parseInt(id.toString().length)

  let addNol = ""
  if (lengthRM !== 9) {
    for (let i = 0; i < 9 - lengthRM; i++) {
      addNol += "0"
    }
  }

  let addNol2 = ""
  if (lengthNoRegis !== 9) {
    for (let i = 0; i < 9 - lengthNoRegis; i++) {
      addNol2 += "0"
    }
  }

  const noRM = `${addNol}${formData.patients_id}`
  const noRegis = `${addNol2}${id}`

  const namaPasien = formData.isexternalrm
    ? formData.rm_name_external
    : formData.nama_rm.toUpperCase()
  const nik = formData.nik
  const umur = `${formData.umur}/${
    parseInt(formData.gender_print) === 1 ? "L" : "P"
  }/${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`

  const regiseMerge = `${noRM}/${noRegis}/${formData.jenis_layanan_print}`
  const dokterName = formData.doctor_name
  const tanggal = defaultDateDisplay(formData.date, true)
  const insuranceType = formData.insurance_name
  window.open(
    `http://localhost/${
      process.env.REACT_APP_PRINT_NAME
    }/public/api/${url}?name=${namaPasien}&nik=${nik}&umur=${umur}&no_rm=${noRM}&regis=${regiseMerge}&dokter=${dokterName}&tanggal=${tanggal}&insurance=${insuranceType}&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
      KODE_PRINTER_SETTING.printer_label
    }`,
    "MsgWindow",
  )
}

export const handleClickCetakManualLabel = (formData, id, url) => {
  const lengthRM = parseInt(formData.patients_id.toString().length)
  const lengthNoRegis = parseInt(id.toString().length)

  let addNol = ""
  if (lengthRM !== 9) {
    for (let i = 0; i < 9 - lengthRM; i++) {
      addNol += "0"
    }
  }

  let addNol2 = ""
  if (lengthNoRegis !== 9) {
    for (let i = 0; i < 9 - lengthNoRegis; i++) {
      addNol2 += "0"
    }
  }

  const noRM = `${addNol}${formData.patients_id}`
  const noRegis = `${addNol2}${id}`

  const namaPasien = formData.isexternalrm
    ? formData.rm_name_external
    : formData.nama_rm.toUpperCase()
  const nik = formData.nik
  const umur = `${formData.umur}/${
    parseInt(formData.gender_print) === 1 ? "L" : "P"
  }/${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`

  const regiseMerge = `${noRM}/${noRegis}/${formData.jenis_layanan_print}`
  const dokterName = formData.doctor_name
  const tanggal = defaultDateDisplay(formData.date, true)
  const insuranceType = formData.insurance_name

  const strWindowFeatures = "location=yes"
  window.open(
    `${
      window.location.origin
    }/print-label-manual?name=${namaPasien}&nik=${nik}&umur=${umur}&no_rm=${noRM}&regis=${regiseMerge}&dokter=${dokterName}&tanggal=${tanggal}&insurance=${insuranceType}&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
      KODE_PRINTER_SETTING.printer_label
    }`,
    "_blank",
    strWindowFeatures,
  )
}

export const handleClickCetakLabelX = (formData, id, url) => {
  const lengthRM = parseInt(formData.patients_id.toString().length)
  const lengthNoRegis = parseInt(id.toString().length)

  let addNol = ""
  if (lengthRM !== 9) {
    for (let i = 0; i < 9 - lengthRM; i++) {
      addNol += "0"
    }
  }

  let addNol2 = ""
  if (lengthNoRegis !== 9) {
    for (let i = 0; i < 9 - lengthNoRegis; i++) {
      addNol2 += "0"
    }
  }

  const noRM = `${addNol}${formData.patients_id}`
  const noRegis = `${addNol2}${id}`

  const namaPasien = formData.isexternalrm
    ? formData.rm_name_external
    : formData.nama_rm.toUpperCase()
  const nik = formData.nik
  const umur = `${formData.umur}/${
    parseInt(formData.gender_print) === 1 ? "L" : "P"
  }/${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`

  const regiseMerge = `${noRM}/${noRegis}/${formData.jenis_layanan_print}`
  const dokterName = formData.doctor_name
  const tanggal = defaultDateDisplay(formData.date, true)
  const insuranceType = formData.insurance_name
  window.open(
    `http://localhost/${
      process.env.REACT_APP_PRINT_NAME
    }/public/api/${url}?name=${namaPasien}&nik=${nik}&umur=${umur}&no_rm=${noRM}&regis=${regiseMerge}&dokter=${dokterName}&tanggal=${tanggal}&insurance=${insuranceType}&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
      KODE_PRINTER_SETTING.printer_label_x
    }`,
    "MsgWindow",
  )
}
export const handleClickCetakLabelAsset = (formData, url, namaRumahSakit) => {
  const nama = formData.name
  const code = formData.code

  window.open(
    `http://localhost/${process.env.REACT_APP_PRINT_NAME}/public/api/${url}?nama=${nama}&code=${code}&nama_rumah_sakit=${namaRumahSakit}`,
    "MsgWindow",
  )
}

export const sebabSakitSelect = [
  {
    value: 0,
    label: "Bukan Kecelakaan lalu lintas [BKLL]",
  },
  {
    value: 1,
    label: "KLL dan bukan kecelakaan Kerja [BKK]",
  },
  {
    value: 2,
    label: "KLL",
  },
  {
    value: 3,
    label: "KK",
  },
]

export const suplesiSelect = [
  {
    value: 0,
    label: "Induk",
  },
  {
    value: 1,
    label: "Suplesi",
  },
]

export const handleClickCetakGelang = (formData, printerEnv, id) => {
  // const namaPasien = formData.nama_rm.toUpperCase();

  // const lengthRM = parseInt(formData.patients_id.toString().length);

  // let addNol = "";
  // if (lengthRM !== 9) {
  //   for (let i = 0; i < 9 - lengthRM; i++) {
  //     addNol += "0";
  //   }
  // }
  // const noRM = `${addNol}${formData.patients_id}`;
  // const tanggalLahir = `${
  //   formData.isexternalrm
  //     ? defaultDateDisplay(formData.date_ob_external, false)
  //     : defaultDateDisplay(formData.date_ob, false)
  // }`;
  // const tanggalRawat = defaultDateDisplay(formData.date, true);
  // return window.open(
  //   `http://localhost/${
  //     process.env.REACT_APP_PRINT_NAME
  //   }/public/api/print-gelang?name=${namaPasien}&no_rm=${noRM}&tanggal_lahir=${tanggalLahir}&jenis_kelamin=${
  //     formData.gender_print
  //   }&tanggal_rawat=${tanggalRawat}&nama_rumah_sakit=${
  //     printerEnv.nama_rumah_sakit
  //   }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
  //     KODE_PRINTER_SETTING.printer_gelang
  //   }`,
  //   "MsgWindow"
  // );

  const lengthRM = parseInt(formData.patients_id.toString().length)
  const lengthNoRegis = parseInt(id.toString().length)

  let addNol = ""
  if (lengthRM !== 9) {
    for (let i = 0; i < 9 - lengthRM; i++) {
      addNol += "0"
    }
  }

  let addNol2 = ""
  if (lengthNoRegis !== 9) {
    for (let i = 0; i < 9 - lengthNoRegis; i++) {
      addNol2 += "0"
    }
  }

  const noRM = `${addNol}${formData.patients_id}`
  const noRegis = `${addNol2}${id}`

  const namaPasien = formData.isexternalrm
    ? formData.rm_name_external
    : formData.nama_rm.toUpperCase()
  const nik = formData.nik
  const umur = `${formData.umur}/${
    parseInt(formData.gender_print) === 1 ? "L" : "P"
  }/${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`

  // const umur = `${
  //   formData.isexternalrm
  //     ? defaultDateDisplay(formData.date_ob_external, false)
  //     : defaultDateDisplay(formData.date_ob, false)
  // }/${parseInt(formData.gender_print) === 1 ? "L" : "P"}/${formData.umur}`;

  const regiseMerge = `${noRM}/${noRegis}/${formData.jenis_layanan_print}`
  const dokterName = formData.doctor_name
  const tanggal = defaultDateDisplay(formData.date, true)
  const insuranceType = formData.insurance_name

  const tanggalLahir = `${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`
  const tanggalRawat = defaultDateDisplay(formData.date, true)
  window.open(
    `http://localhost/${
      process.env.REACT_APP_PRINT_NAME
    }/public/api/print-gelang?name=${namaPasien}&nik=${nik}&umur=${umur}&no_rm=${noRM}&regis=${regiseMerge}&dokter=${dokterName}&tanggal=${tanggal}&insurance=${insuranceType}&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
      KODE_PRINTER_SETTING.printer_gelang
    }&tanggal_lahir=${tanggalLahir}&jenis_kelamin=${
      formData.gender_print
    }&tanggal_rawat=${tanggalRawat}&nama_rumah_sakit=${
      printerEnv.nama_rumah_sakit
    }`,
    "MsgWindow",
  )
}

export const handleClickCetakGelangBayi = (formData, id) => {
  /**
   * OLD SEBELUM AKRE
   */
  // const namaPasien = formData.nama_rm.toUpperCase();
  // const lengthRM = parseInt(formData.patients_id.toString().length);
  // let addNol = "";
  // if (lengthRM !== 9) {
  //   for (let i = 0; i < 9 - lengthRM; i++) {
  //     addNol += "0";
  //   }
  // }
  // const noRM = `${addNol}${formData.patients_id}`;
  // const tanggalLahir = `${
  //   formData.isexternalrm
  //     ? defaultDateDisplay(formData.date_ob_external, false)
  //     : defaultDateDisplay(formData.date_ob, false)
  // }`;
  // const tanggalRawat = defaultDateDisplay(formData.date, true);
  // return window.open(
  //   `http://localhost/${
  //     process.env.REACT_APP_PRINT_NAME
  //   }/public/api/print-gelang-bayi?name=${namaPasien}&no_rm=${noRM}&tanggal_lahir=${tanggalLahir}&jenis_kelamin=${
  //     formData.gender_print
  //   }&tanggal_rawat=${tanggalRawat}&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
  //     KODE_PRINTER_SETTING.printer_gelang_bayi
  //   }`,
  //   "MsgWindow"
  // );

  const lengthRM = parseInt(formData.patients_id.toString().length)
  const lengthNoRegis = parseInt(id.toString().length)

  let addNol = ""
  if (lengthRM !== 9) {
    for (let i = 0; i < 9 - lengthRM; i++) {
      addNol += "0"
    }
  }

  let addNol2 = ""
  if (lengthNoRegis !== 9) {
    for (let i = 0; i < 9 - lengthNoRegis; i++) {
      addNol2 += "0"
    }
  }

  const noRM = `${addNol}${formData.patients_id}`
  const noRegis = `${addNol2}${id}`

  const namaPasien = formData.isexternalrm
    ? formData.rm_name_external
    : formData.nama_rm.toUpperCase()
  const nik = formData.nik
  const umur = `${formData.umur}/${
    parseInt(formData.gender_print) === 1 ? "L" : "P"
  }/${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`

  const regiseMerge = `${noRM}/${noRegis}/${formData.jenis_layanan_print}`
  const dokterName = formData.doctor_name
  const tanggal = defaultDateDisplay(formData.date, true)
  const insuranceType = formData.insurance_name

  const tanggalLahir = `${
    formData.isexternalrm
      ? defaultDateDisplay(formData.date_ob_external, false)
      : defaultDateDisplay(formData.date_ob, false)
  }`
  const tanggalRawat = defaultDateDisplay(formData.date, true)

  window.open(
    `http://localhost/${
      process.env.REACT_APP_PRINT_NAME
    }/public/api/print-gelang-bayi?name=${namaPasien}&nik=${nik}&umur=${umur}&no_rm=${noRM}&regis=${regiseMerge}&dokter=${dokterName}&tanggal=${tanggal}&insurance=${insuranceType}&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
      KODE_PRINTER_SETTING.printer_gelang_bayi
    }&tanggal_lahir=${tanggalLahir}&jenis_kelamin=${
      formData.gender_print
    }&tanggal_rawat=${tanggalRawat}`,
    "MsgWindow",
  )
}

export const getSearchMultiNoRujukan = async (nomor_kartu, type = "pcare") => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_kartu,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rujukan/${type}/no-kartu-multi`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.rujukan,
      }
    } else {
      return {
        state: false,
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getSearchSEPByNoKartu = async (nomor_kartu, type = "pcare") => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_kartu,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rujukan/${type}/no-kartu`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response,
      }
    } else {
      return {
        state: false,
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getSearchSEP = async (formData) => {
  try {
    const withNIK = {
      nik_ktp: formData.nomor_kartu,
      tgl_pelayanan: formData.tgl_pelayanan,
    }

    const withBPJS = {
      nomor_kartu: formData.nomor_kartu,
      tgl_pelayanan: formData.tgl_pelayanan,
    }

    const data = formData.type === "1" ? withBPJS : withNIK

    const api = await instance1.post(`/bridging`, data, {
      headers: {
        method: "post",
        url: `${
          formData.type === "1"
            ? `${BASE_URL_VCLAIM}/${V1}/emr/bridging/peserta/no-kartu-bpjs`
            : `${BASE_URL_VCLAIM}/${V1}/emr/bridging/peserta/nik`
        }`,
      },
    })

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response,
      }
    } else {
      return {
        state: false,
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getDetailRujukanByNoRujukan = async (
  nomor_rujukan,
  type = "pcare",
) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_rujukan: nomor_rujukan,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rujukan/${
            type.toLowerCase() === "pcare" || type.toLowerCase() === "sep"
              ? "pcare"
              : "rs"
          }/no-rujuk`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.rujukan,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getDetailSuratKontrolByNoRujukan = async (nomor_rujukan) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_surat_kontrol_peserta: nomor_rujukan,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/cari-no-surat-kontrol`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getDetailSepInEmr = async (no_sep) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_sep_peserta: no_sep,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/sep/cari`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getDetailSepInEmrByRencanaKontrol = async (no_sep) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_sep: no_sep,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/cari-sep`,
        },
      },
    ) 

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export { getDetailSepInEmrByRencanaKontrol as getDetailSepByNoSep }

export const getDiagnosa = async (diagnosa) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        diagnosa,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/referensi/diagnosa`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.diagnosa,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getReferensiFaskes = async (kode_faskes) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        kode_faskes,
        jenis_faskes: "2",
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/referensi/faskes`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.faskes,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const useFaskes = (kode_faskes) => {
  const DEFAULT_OPTION = []
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      if (!isNull(kode_faskes)) {
        setLoading(true)
        const res = await getReferensiFaskes(kode_faskes)
        if (res.state) {
          const data = []
          res.data.map((item) => {
            return data.push({
              value: item.kode,
              label: item.nama,
            })
          })

          setState(data)
          setLoading(false)
        } else {
          setLoading(false)
          setState([])
        }
      } else {
        setState([])
      }
    })()
  }, [kode_faskes]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    kodeFaskes: state,
    loadingFaskes: loading,
  }
}

export const useDiagnosa = (diagnosa) => {
  const DEFAULT_OPTION = []
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      if (!isNull(diagnosa)) {
        setLoading(true)
        const res = await getDiagnosa(diagnosa)
        if (res.state) {
          const data = []
          res.data.map((item) => {
            return data.push({
              value: item.kode,
              label: item.nama,
            })
          })

          setState(data)
          setLoading(false)
        } else {
          setLoading(false)
          setState([])
        }
      } else {
        setState([])
      }
    })()
  }, [diagnosa])

  return {
    diagnosa: state,
    loading: loading,
  }
}

export const useModalBukaKunjungan = (id, setNewData) => {
  const [showModalConfirm, setShowModalConfirm] = useState(false)
  const handleSubmit = async () => {
    try {
      await instance2.post(
        "/registration/registration/buka-kembali-registrasi",
        {
          id,
        },
      )
      setShowModalConfirm(false)
      defaultToastSuccess("Berhasil buka kunjungan")
      setNewData()
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  const ButtonBukaKunjungan = () => {
    return (
      <MasterButton
        type="button"
        color={"primary-cyan"}
        name={"Buka Kunjungan"}
        onClick={() => setShowModalConfirm(!showModalConfirm)}
        size="md"
      />
    )
  }

  const ModalConfirmBukaKunjungan = () => {
    return (
      <>
        {showModalConfirm && (
          <ModalDeleteConfirm
            confirmHandle={handleSubmit}
            msg="Apakah anda yakin ingin membuka kunjungan ini?"
            setShowModalDeleteConfirm={() => setShowModalConfirm(false)}
            labelConfirm="Ya, Buka Kunjungan"
            title="Buka Kunjungan"
          />
        )}
      </>
    )
  }

  return {
    ButtonBukaKunjungan,
    ModalConfirmBukaKunjungan,
  }
}

export const useModalCancelKunjungan = ({
  setNewData,
  registrationId,
  setRegistrationId,
  defaultAlasan,
}) => {
  const [showModalCancel, setShowModalCancel] = useState(false)

  const ButtonCancelKunjungan = () => {
    return (
      <MasterButton
        type="button"
        color={"warning"}
        name={"Batal Kunjungan"}
        onClick={() => setShowModalCancel(!showModalCancel)}
        size="md"
      />
    )
  }

  const ModalCancelKunjungan = () => {
    return (
      <>
        {showModalCancel && (
          <ModalCancel
            registrationId={registrationId}
            setRegistrationId={setRegistrationId}
            setNewData={setNewData}
            defaultAlasan={defaultAlasan}
            setShowModal={() => setShowModalCancel(false)}
          />
        )}
      </>
    )
  }

  return {
    ButtonCancelKunjungan,
    ModalCancelKunjungan,
  }
}

const detailPasienByType = (type, noRujukan) => {
  switch (type) {
    case "SEP":
      return getDetailSepInEmrByRencanaKontrol(noRujukan)

    case "RS":
      return getDetailRujukanByNoRujukan(noRujukan, "rs")

    case "PCARE":
      return getDetailRujukanByNoRujukan(noRujukan)

    default:
      return getDetailRujukanByNoRujukan(noRujukan)
  }
}

const getDataSepByType = async (type, noKartu) => {
  switch (type) {
    case "RS":
      return await getSearchSEPByNoKartu(noKartu, "rs")

    case "SEP":
      return await getSearchSEPByNoKartu(noKartu, "rs")

    case "PCARE":
      return await getSearchSEPByNoKartu(noKartu)

    default:
      return await getSearchSEPByNoKartu(noKartu)
  }
}



export const ModalSearchSEP = ({
  handleSetSEP,
  patientID,
  noBPJS,
  type = "RJ",
  noRujukan,
  typeNoRujukan,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SEARCH)

  const [formData, setFormData] = useState({
    tgl_pelayanan: today(),
    nomor_kartu: noBPJS,
    type: "1",
  })

  React.useEffect(() => {
    setFormData({
      ...formData,
      nomor_kartu: noBPJS,
    })
  }, [noBPJS])

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  /**
   * ingin mendapatakan no rujukan
   *
   * ketika disubmit, cek typenya
   *
   * jika type = 1 (BPJS) maka handleSubmit menggunakan endpoint /emr/bridging/peserta/no-kartu-bpjs
   *
   * jika type = 2 (NIK) maka handleSubmit menggunakan endpoint /emr/bridging/peserta/nik
   *
   * =========================================================
   *
   * SEBELUM RS/POST RANAP MENYERANG
   * sedangkan untuk mendapatkan no rujukan menggunakan endpoint /emr/bridging/rujukan/pcare/     no-kartu
   * jika menggunakan BPJS, langsung hit ep no rujukan karena sudah ada no kartunya
   * jika menggunakan NIK, maka no kartu ambil dari response handleSubmit terlebih dahulu
   *
   * ===========================================================
   *
   * TYPE NO RUJUKAN
   *
   * DALAM PEMBUATAN SEP No Rujukan mengambil dari 3 sumber
   *
   * Jika rujukan mengambil dari history SEP maka menggunakan endpoint getDetailSepInEmrByRencanaKontrol
   * Jika rujukan mengambil dari no rujukan pcare maka menggunakan endpoint getDetailRujukanByNoRujukan('pcare')
   * Jika rujukan mengambil dari no rujukan rs maka menggunakan endpoint getDetailRujukanByNoRujukan('rs')
   *
   * NOTE POST RANAP
   *
   * Umumnya kode ppk diambil dari endpoint no rujukan
   * tapi jika dia post ranap atau sumbernya dari history sep maka diambil dari endpoint no kartu
   *
   * ternyata ada case berbeda, bisa aja rujukan dari faskes itu kosong, jadi validasi pencarian nomor rujukan by nomor kartu dicopot
   * dan mengambil ppk dari endpoint cari-sep
   *
   *
   */

  const handleSubmit = async (e) => {
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      const res = await getSearchSEP(formData)
      if (res.state) {
        setDisabled(DEFAULT_SHOW_BUTTON_SEARCH)

        if (formData.type === "1") {
          const getProfilPasien = async () => instance2.get(urlFilterInternal, {
            headers: {
              idrm: removeZeroInFront(patientID.toString()),
              limit: 1,
              pages: 1,
              jenisrm: parseInt(2),
              status:1,
            },

          });
          /**
           * Langsung cari no rujukan dg nokartu
           * Tapi, jika igd tidak menggunakan endpoint ini
           * 
           *    "provUmum": {
                    "kdProvider": "10250107",
                    "nmProvider": "PUSKESMAS BUGEL"
                },
           *
           */

          if (type === "RJ") {
            const pcare = getDataSepByType(typeNoRujukan, formData.nomor_kartu)
            const detailPasien = detailPasienByType(typeNoRujukan, noRujukan)

            await Promise.all([pcare, detailPasien, getProfilPasien]).then((responses) => {
              const responseDetailPasien = responses[1]
              const responseProfilPasien = responses[2]

              if (responseDetailPasien.state) {

                const responseDetailPasienData = responseDetailPasien.data

                const isTypeSEP = typeNoRujukan === "SEP"

                const kodeDiagnosa = isTypeSEP
                  ? responseDetailPasienData.diagnosa.split(" - ")[0]
                  : responseDetailPasienData?.diagnosa.kode

                const namaDiagnosa = isTypeSEP
                  ? responseDetailPasienData.diagnosa
                  : `${responseDetailPasienData?.diagnosa.kode} - ${responseDetailPasienData?.diagnosa.nama}`

                const tglRujukan = isTypeSEP
                  ? responseDetailPasienData.tglSep
                  : responseDetailPasienData?.tglKunjungan

                const ppkRujukan = responses[1].data?.provPerujuk
                const kodePpkRujukan = isTypeSEP
                  ? ppkRujukan.kdProviderPerujuk
                  : ppkRujukan.kode
                const namaPpkRujukan = isTypeSEP
                  ? ppkRujukan.nmProviderPerujuk
                  : ppkRujukan.nama

                const noRujuk = isTypeSEP
                  ? noRujukan
                  : responses[0].data?.rujukan?.noKunjungan

                const poliTujuanPrint = isTypeSEP
                  ? "-"
                  : responses[0].data?.rujukan?.poliRujukan.nama

                const nomor_telp = responseProfilPasien?.data?.body?.[0]?.mobile_phone_number??null;

                handleSetSEP({
                  ...res.data,
                  tgl_pelayanan: formData.tgl_pelayanan,
                  no_rujukan: noRujuk,
                  ppk_rujukan_kode: kodePpkRujukan,
                  ppk_rujukan_name: namaPpkRujukan,
                  tgl_rujukan: tglRujukan,
                  poli_tujuan_print: poliTujuanPrint,
                  status: 1,
                  diagnosa_awal: kodeDiagnosa,
                  diagnosa_awal_name: namaDiagnosa,
                  nomor_telp: nomor_telp,
                })

              } else {
                const msgPcare = responses[0].state ? "" : responses[0].message
                const msgDetail = responses[1].state ? "" : responses[1].message

                defaultToastError(
                  "Gagal mengambil data. Error " + msgPcare + " " + msgDetail,
                )
              }
            })
          } else {
            const profilPasien = await getProfilPasien();
            const nomor_telp = profilPasien?.data?.body?.[0]?.mobile_phone_number??null;
            handleSetSEP({
              ...res.data,
              tgl_pelayanan: formData.tgl_pelayanan,
              no_rujukan: "",
              ppk_rujukan_kode:
                type === "IGD"
                  ? res.data?.peserta.provUmum.kdProvider
                  : KODE_PPK_RUJUKAN,
              ppk_rujukan_name:
                type === "IGD"
                  ? res.data?.peserta?.provUmum.nmProvider
                  : NAMA_PPK_RUJUKAN,
              tgl_rujukan: "",
              poli_tujuan_print: type === "IGD" ? POLI_TUJUAN_IGD : "-",
              status: 1,
              diagnosa_awal: "",
              diagnosa_awal_name: "",
              nomor_telp: nomor_telp,
            })
          }
        } else {
          /**
           * ambil no kartu dari response dan cari
           */

          if (type === "RJ") {
            const pcare = await getDataSepByType(
              typeNoRujukan,
              res.data.peserta.noKartu,
            )
            const detailPasien = detailPasienByType(typeNoRujukan, noRujukan)

            await Promise.all([pcare, detailPasien]).then((responses) => {
              const responseDetailPasien = responses[1]
              if (responses[0].state && responseDetailPasien.state) {
                const responseDetailPasienData = responseDetailPasien.data

                const tglRujukan =
                  typeNoRujukan === "SEP"
                    ? responseDetailPasienData.tglSep
                    : responseDetailPasienData?.rujukan?.tglKunjungan

                const dataResRujuk = responses[0].data?.rujukan

                handleSetSEP({
                  ...res.data,
                  tgl_pelayanan: formData.tgl_pelayanan,
                  status: 1,
                  no_rujukan: dataResRujuk?.noKunjungan,
                  ppk_rujukan_kode: dataResRujuk?.provPerujuk.kode,
                  ppk_rujukan_name: dataResRujuk?.provPerujuk.nama,
                  tgl_rujukan: tglRujukan,
                  poli_tujuan_print: dataResRujuk?.poliRujukan.nama,
                  diagnosa_awal: dataResRujuk?.diagnosa.kode,
                  diagnosa_awal_name: `${dataResRujuk?.diagnosa.kode} - ${dataResRujuk?.diagnosa.nama}`,
                })
              } else {
                const msgPcare = responses[0].state ? "" : responses[0].message
                const msgDetail = responses[1].state ? "" : responses[1].message

                defaultToastError(
                  "Gagal mengambil data. Error " + msgPcare + " " + msgDetail,
                )
              }
            })
          } else {
            handleSetSEP({
              ...res.data,
              tgl_pelayanan: formData.tgl_pelayanan,
              no_rujukan: "",
              ppk_rujukan_kode:
                type === "IGD"
                  ? res.data?.peserta.provUmum.kdProvider
                  : KODE_PPK_RUJUKAN,
              ppk_rujukan_name:
                type === "IGD"
                  ? res.data?.peserta?.provUmum.nmProvider
                  : NAMA_PPK_RUJUKAN,
              tgl_rujukan: "",
              poli_tujuan_print: type === "IGD" ? POLI_TUJUAN_IGD : "-",
              status: 1,
              diagnosa_awal: "",
              diagnosa_awal_name: "",
            })
          }
        }
      } else {
        setDisabled(DEFAULT_SHOW_BUTTON_SEARCH)
        defaultToastError(res.message)
        handleSetSEP({
          status: 0,
        })
      }
    } catch (error) {
      console.log("error", error)
      handleSetSEP({
        status: 0,
      })
      defaultToastError(error.response?.data?.message?.metaData?.message)
      setDisabled(DEFAULT_SHOW_BUTTON_SEARCH)
    }
  }

  return (
    <Grid container>
      <Grid item sm={12}>
        <InputTextMaster
          name="tgl_pelayanan"
          label="TANGGAL PELAYANAN"
          id="tgl_pelayanan"
          type="date"
          value={formData.tgl_pelayanan}
          onChange={handleChange("tgl_pelayanan")}
          placeholder="Tanggal Pelayanan"
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="nomor_kartu"
          label="NIK/No BPJS"
          id="nomor_kartu"
          value={formData.nomor_kartu}
          onChange={handleChange("nomor_kartu")}
          placeholder="NIK/No BPJS"
        />
      </Grid>

      <Grid item sm={12}>
        <div
          className="mt-1"
          style={{
            display: "flex",
            gap: "20px",
          }}
        >
          <InputRadioButton
            label={"BPJS"}
            size={"15"}
            id="type"
            name="type"
            value="1"
            initialValue={formData.type}
            onChange={(e) =>
              setFormData({
                ...formData,
                type: "1",
              })
            }
          />

          <InputRadioButton
            label={"NIK"}
            size={"15"}
            id="type"
            name="type"
            value="2"
            initialValue={formData.type}
            onChange={(e) =>
              setFormData({
                ...formData,
                type: "2",
              })
            }
          />
        </div>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <MasterButton
          className={"mt-1"}
          type="button"
          onClick={(e) => handleSubmit(e)}
          color={disabled.color}
          name={disabled.label}
          size="md"
        />
      </Grid>
    </Grid>
  )
}

export const CountHarian = (url) => {
  const [state, setState] = useState([])
  useEffect(() => {
    instance2
      .get(url, {
        headers: {
          dates: today(),
        },
      })
      .then((res) => {
        setState(res.data.totaldata)
      })
      .catch((err) => console.log(err))
  }, [setState, url])
  return state
}

const getKategori = async (kode, asuransi, id_kelas, id_dokter) => {
  try {
    const response = await instance3.get(
      `master/auto_billing/get-data-penjualan-otomatis?kode_kategori=${kode}&id_asuransi=${asuransi}&id_kelas_kunjungan=${id_kelas}&id_dokter=${id_dokter}`,
    )

    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.body,
      }
    } else {
      return {
        state: false,
        data: {},
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {},
    }
  }
}

export const createPenjualan = async ({
  dokterID,
  asuransiNo,
  rmID,
  rmName,
  kunjunganID,
  type,
  asuransiBpjsId,
  kelasID,
  jenisLayananID,
}) => {
  try {
    const resKategori = await getKategori(
      type,
      asuransiBpjsId,
      kelasID,
      dokterID,
    )
    if (!resKategori.state) {
      return {
        state: false,
        message:
          "Registrasi berhasil, namun gagal membuat penjualan otomatis. [KATEGORI TIDAK DITEMUKAN]",
      }
    }

    const dataResKategori = resKategori.data
    const defaultData = {
      date: toUTCFormat(today(true)),
      id_type_of_care: 1,
      id_jenis_layanan: jenisLayananID,
      id_kelas: kelasID,
      harga_total_barang: dataResKategori.harga_total_barang,
      harga_total_jasa: dataResKategori.harga_total_jasa,
      harga_total_fasilitas: dataResKategori.harga_total_fasilitas,
      harga_total_rikjang: dataResKategori.harga_total_rikjang,
      harga_total_paket: dataResKategori.harga_total_paket,
      discount: 0,
      jumlah_set_discount: 0,
      tax: 0,
      jumlah_tax: 0,
      total_Penjualan: dataResKategori.total_Penjualan,
      is_lock: false,
      is_close: false,
      kas_id: dataResKategori.id_kas,
      msTipePembayaranId: dataResKategori.id_tipe_pembayaran,
      petugas: getUserName(),
      id_dokter: dokterID,
      sumber_penj: SUMBER_PENJUALAN_OTOMATIS_REGISTRASI,
      gudang_id: dataResKategori.id_gudang,
      insurance_id: asuransiBpjsId,
      insurance_no: asuransiNo,
      id_rm: rmID,
      namaGudang: dataResKategori.nama_gudang,
      nama_rm: rmName,
      fasilitas: dataResKategori.fasilitas,
      jasa: dataResKategori.jasa,
      rikjang: dataResKategori.rikjang,
      paket: dataResKategori.paket,
      barang: dataResKategori.item,
      status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
      isExternal: 0,
      bayar_jual: 0,
      id_kunjungan: kunjunganID,
      sisa: dataResKategori.total_Penjualan,
    }

    const response = await instance3.post("/penjualan/register", defaultData)
    if (response.data.status === 200) {
      return {
        state: true,
        message: "success",
      }
    } else {
      return {
        state: false,
        message: "Registrasi berhasil, namun gagal membuat penjualan otomatis",
      }
    }

    // Codingan sebelum ada penjualan otomatis
    // let JASA_RAWAT_JALAN;
    // let hargaTotalJasa;
    // /**
    //  * cek jika type rawat jalan
    //  * cek dokter tersebut sudah termaping atau belum
    //  * jika belum jasa nya []
    //  * */
    // if (type === "rawat jalan") {
    //   const res = await getJasaDokterByMsJasa(JASA_ID_RJ);
    //   const check = res.data.filter((item) => item.id_dokter === dokterID);
    //   if (check.length > 0) {
    //     hargaTotalJasa = TOTAL_JASA_RAWAT_JALAN;
    //     JASA_RAWAT_JALAN = [
    //       {
    //         ...JASA_RJ,
    //         doctor_id: dokterID,
    //       },
    //     ];
    //   } else {
    //     hargaTotalJasa = 0;
    //     JASA_RAWAT_JALAN = [];
    //   }
    // } else {
    //   hargaTotalJasa = TOTAL_JASA_IGD;
    // }
    // const defaultData = {
    //   date: toUTCFormat(today(true)),
    //   id_type_of_care: 1,
    //   id_jenis_layanan:
    //     type === "rawat jalan"
    //       ? JENIS_LAYANAN_RAWAT_JALAN_ID
    //       : JENIS_LAYANAN_IGD_ID,
    //   id_kelas: KELAS_NON_KELAS,
    //   harga_total_barang: 0,
    //   harga_total_jasa: hargaTotalJasa,
    //   harga_total_fasilitas: TOTAL_FASILITAS_RAWAT_JALAN,
    //   harga_total_rikjang: 0,
    //   harga_total_paket: 0,
    //   discount: 0,
    //   jumlah_set_discount: 0,
    //   tax: 0,
    //   jumlah_tax: 0,
    //   total_Penjualan:
    //     type === "rawat jalan"
    //       ? TOTAL_PENJUALAN_RAWAT_JALAN
    //       : TOTAL_PENJUALAN_IGD,
    //   is_lock: false,
    //   is_close: false,
    //   kas_id: KAS_RAJAL_ID,
    //   msTipePembayaranId: 1,
    //   petugas: getUserName(),
    //   id_dokter: dokterID,
    //   sumber_penj: SUMBER_PENJUALAN_OTOMATIS_REGISTRASI,
    //   gudang_id: type === "rawat jalan" ? GUDANG_POLIKLINIK_ID : GUDANG_IGD_ID,
    //   insurance_id: asuransiBpjsId,
    //   insurance_no: asuransiNo,
    //   id_rm: rmID,
    //   namaGudang:
    //     type === "rawat jalan" ? GUDANG_POLIKLINK_NAME : GUDANG_IGD_NAME,
    //   nama_rm: rmName,
    //   fasilitas: FASILITAS,
    //   jasa: type === "rawat jalan" ? JASA_RAWAT_JALAN : JASA_IGD,
    //   rikjang: [],
    //   paket: [],
    //   barang: [],
    //   status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
    //   isExternal: 0,
    //   bayar_jual: 0,
    //   id_kunjungan: kunjunganID,
    //   sisa:
    //     type === "rawat jalan"
    //       ? TOTAL_PENJUALAN_RAWAT_JALAN
    //       : TOTAL_PENJUALAN_IGD,
    // };
    // const response = await instance3.post("/penjualan/register", defaultData);
    // if (response.data.status === 200) {
    //   return {
    //     state: true,
    //     message: "success",
    //   };
    // } else {
    //   return {
    //     state: false,
    //     message: "Registrasi berhasil, namun gagal membuat penjualan otomatis",
    //   };
    // }
  } catch (error) {
    return {
      state: false,
      message: "Registrasi berhasil, namun gagal membuat penjualan otomatis",
    }
  }
}

export const checkJasaDokter = async (dokterID, jasaID) => {
  const res = await getJasaDokterByMsJasa(jasaID)
  const check = res.data.filter((item) => item.id_dokter === dokterID)
  return check.length > 0 ? true : false
}

export const StatusKunjungan = ({ status, iscancel }) => {
  if (status && !iscancel) {
    return <MasterButton type="button" name="Tidak Aktif" color="secondary" />
  } else if (status && iscancel) {
    return (
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
        }}
      >
        <MasterButton type="button" name="Tidak Aktif" color="secondary" />

        <MasterButton type="button" name="Dibatalkan" color="danger" />
      </div>
    )
  } else if (!status && !iscancel) {
    return <MasterButton type="button" name="Aktif" color="lightgreen" />
  } else if (!status && iscancel) {
    return (
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
        }}
      >
        <MasterButton type="button" name="Aktif" color="lightgreen" />

        <MasterButton type="button" name="Dibatalkan" color="danger" />
      </div>
    )
  } else {
  }
}

export const StatusRaber = ({ status }) => {
  if (!status) {
    return <MasterButton type="button" name="Tidak Rawat Bersama" color="secondary" />
  } else {
    return <MasterButton type="button" name="Rawat Bersama" color="lightgreen" />
  }
}

export const validasiNoBpjs = async (nomor_kartu) => {
  const response = await getSearchSEP({
    type: "1",
    nomor_kartu: nomor_kartu,
    tgl_pelayanan: today(),
  })

  if (response.state) {
    if (parseInt(response.data.peserta.statusPeserta.kode) === 0) {
      const dataRes = response.data.peserta
      return {
        state: true,
        message: "aktif",
        data: {
          hakKelas: dataRes.hakKelas,
          provUmum: dataRes.provUmum,
        },
      }
    } else {
      return {
        state: false,
        message:
          "Nomor BPJS tidak aktif atau " +
          response.data.peserta.statusPeserta.keterangan,
      }
    }
  } else {
    return {
      state: false,
      message: "NO BPJS tidak ditemukan",
    }
  }
}

export const getCaraMasuk = (crMasuk) => {
  if (isNull(crMasuk)) {
    return {
      cara_masuk: "",
      cara_masuk_name: "",
    }
  } else {
    const caraMasuk = optionCaraMasuk.find((x) => x.value === crMasuk)
    return {
      cara_masuk: caraMasuk?.value.toString(),
      cara_masuk_name: caraMasuk?.label,
    }
  }
}
export const getCekResepIter = async (nomor_rm) => {
  try {
    const response = await instancePenunjang.get(
      `farmasi-rajal/obat-kronis/cek-resep-iterasi`,
      {
        params: {
          patients_id: nomor_rm
        }
      }
    )

    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.data,
      }
    } else {
      return {
        state: false,
        data: {},
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {},
    }
  }
};

export const postResepIter = async (data) => {
  try {
    const payload = {
      "id_kunjungan": data.id_kunjungan,
      "id_iterasi_resep": data.id_iterasi_resep,
      "tanggal_registrasi": data.tanggal_registrasi,
      "id_resep_kronis": data.id_resep_kronis,
    }
    const response = await instancePenunjang.post("/farmasi-rajal/obat-kronis/proses-resep-iterasi", payload);

    if (response.data.status === 201) {
      return {
        state: true,
        data: response.data.message,
      }
    } else {
      return {
        state: false,
        data: {},
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {},
    }
  }
};
